import type { FC } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import { MediaImageSized } from '@/features/media/components/MediaImageSized';
import type { MediaItemPlaceholder } from '@/features/media/types/picker';

type Props = {
  style?: StyleProp<ViewStyle>;
  mediaItemPlaceholder: MediaItemPlaceholder;
  onDelete?: (mediaItemPlaceholder: MediaItemPlaceholder) => void;
  uploading?: boolean;
};

/**
 * Picker-placeholder adapter around MediaImageSized, used by
 * MediaItemPlaceholderList (post editor, chat, comment editor).
 */
export const MediaItemPlaceholderImage: FC<Props> = ({
  style,
  mediaItemPlaceholder,
  onDelete,
  uploading = false
}) => (
  <MediaImageSized
    style={style}
    mediaItem={mediaItemPlaceholder.mediaItem}
    localImageUri={mediaItemPlaceholder.localUri}
    isLoading={uploading}
    onRemove={onDelete ? () => onDelete(mediaItemPlaceholder) : undefined}
  />
);
